import { locale } from '../../Services/Tools/reducers';

const quotations = {
  list: [],
  quotation: [],
  products: [],
  productsCalc: {},
  offerV2: {},
  commercialproducts: [],
  current: {
    redirect: false,
  },
  duplicateSR: {},
  loading: {
    isLoadingProduct: false,
    isLoadingQuotations: false,
    isLoadingQuotation: false,
    isSavingQuotations: false,
    isCreatingQuotations: false,
    isCalculatingQuotation: false,
    isSubmittingQuotation: false,
    isLoadingProducts: false,
    isLocaleLoaded: false,
    isLoadingValidate: false,
  },
  alerts: {
    errors: [],
    warnings: [],
    infos: [],
    successes: [],
  },
  defaultValues: { allowed_direct_debit_day: 5 },
  config: {
    covered: {
      genders: {
        label: 'Gender',
        options: [
          { text: '', value: '' },
          { text: 'Mme', value: 'female' },
          { text: 'M.', value: 'male' },
        ],
      },
    },
    loan: {
      kind: {
        label: 'Kind',
        options: [
          { text: 'Amortissable', value: 'fixed_rate' },
          { text: 'Taux Zéro', value: 'interest_free' },
          { text: 'Palier', value: 'graduated' },
          { text: 'Relais', value: 'intermediate' },
          { text: 'In Fine', value: 'balloon' },
        ],
      },
      deferral: {
        label: 'Deferral',
        options: [
          { text: '', value: '' },
          { text: 'Différé Partiel', value: 'partially' },
          { text: 'Différé Total', value: 'fully' },
        ],
      },
      duration_unit: {
        label: 'Unité',
        options: [
          { text: 'Mois', value: 'month' },
          { text: 'Année', value: 'year' },
        ],
        initialValue: 'month',
      },
      payment_frequency: {
        label: 'Fréquence de paiement',
        options: [
          { text: 'Mensuelle', value: 'month' },
          { text: 'Trimestrielle', value: 'quarter' },
          { text: 'Semestrielle', value: 'half_year' },
          { text: 'Annuelle', value: 'year' },
        ],
        initialValue: 'month',
      },
      lenders: {
        label: 'Organisme prêteur',
        options: [],
        type: 'lender',
      },
      lenderAddresses: {
        label: "Adresse de l'organisme prêteur",
        options: [],
        type: 'lenderAddress',
      },
    },
  },
  strings: locale('fr', 'quotation'),
  filters: {
    query: '',
    status: ['submitted', 'project', 'pending'],
    commercialProductId: [],
  },
};

export default quotations;
